var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"object-story"},[_c('div',{staticClass:"container"},[_c('object-story-single',{attrs:{"pageType":'editor.ThemeObjectCollection'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }